import { render, staticRenderFns } from "./MsgsQueueModal.vue?vue&type=template&id=7b69aff2&scoped=true"
import script from "./MsgsQueueModal.vue?vue&type=script&lang=js"
export * from "./MsgsQueueModal.vue?vue&type=script&lang=js"
import style0 from "./MsgsQueueModal.vue?vue&type=style&index=0&id=7b69aff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b69aff2",
  null
  
)

export default component.exports